import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <div className="footer-bottom">
      © All Rights Reserved | AavryaaFabHub |  House of Geetha 
    </div>
  );
};

export default Footer;
